/* eslint-disable */
enum CommonNoteType {
  OTHER = 'other'
}

export default CommonNoteType
